// extracted by mini-css-extract-plugin
export var billingAddress = "_qj-g";
export var contactInfo = "_qj-d";
export var customerInfoContainer = "_qj-c";
export var customerInfoContainerMobile = "_qj-h";
export var customerInfoRow = "_qj-a";
export var customerInfoSection = "_qj-b";
export var fullWidthDividerMobile = "_qj-i";
export var imageContainer = "_qj-1";
export var paymentMethod = "_qj-e";
export var priceText = "_qj-6";
export var priceTextMobile = "_qj-7";
export var product = "_qj-0";
export var productImage = "_qj-2";
export var productInfo = "_qj-4";
export var productMobile = "_qj-9";
export var productTitle = "_qj-8";
export var quantityBadge = "_qj-3";
export var quantityText = "_qj-5";
export var shippingAddress = "_qj-f";